import React from "react";
import Avatar from "@mui/material/Avatar";
import PropTypes from "prop-types";

import useStyles from "./styles";

const CustomAvatar = (props) => {
  const { size, url, firstLetter, lastLetter, backgroundColor, onClick } =
    props;
  const classes = useStyles();

  return (
    <div className={classes.avatarContainer} onClick={onClick}>
      {!!url ? (
        <Avatar src={url} sx={{ width: size, height: size }} />
      ) : (
        <Avatar sx={{ bgcolor: backgroundColor, width: size, height: size }}>
          {`${firstLetter}${lastLetter}`}
        </Avatar>
      )}
    </div>
  );
};

CustomAvatar.propTypes = {
  size: PropTypes.number,
  url: PropTypes.string,
  firstLetter: PropTypes.string,
  lastLetter: PropTypes.string,
  backgroundColor: PropTypes.string,
  onClick: PropTypes.func,
};

CustomAvatar.defaultProps = {
  url: "",
  firstLetter: "",
  lastLetter: "",
  backgroundColor: "#BD10E0",
  onClick: () => {},
};
export default CustomAvatar;
